// added for green border and font when got selected
// added for green border and font when got selected
export const initFormSuccessHandler = () => {

  const isTrackedField = (field) => {
    return (
      field &&
      (field.tagName === "INPUT" ||
        field.tagName === "TEXTAREA" ||
        field.tagName === "SELECT")
    );
  };

  // check if field is inside form
  const isInsideForm = (field) => {
    return field && field.closest("form") !== null;
  };

  const isInsideLogoFormWrapper = (field) => {
    return field && field.closest(".logo-form-wrapper") !== null;
  };

  const applySuccess = (field) => {
    if (!isTrackedField(field)) return;
    if (!isInsideForm(field)) return; // ONLY FORM FIELDS

    const parent = field.closest(".ctm-form-control-textarea");

    if (isInsideLogoFormWrapper(field)) {
      field.classList.remove("ctm-success");
      parent?.classList.remove("ctm-success");
      return;
    }

    const currentValue = field.value ?? "";

    // VALID CHECK
    const isValid = currentValue.toString().trim() !== "";

    // SET TOUCHED ONLY ON FIRST CHANGE
    if (!field.dataset.touched) {
      const initialValue = field.dataset.initialValue ?? "";

      if (currentValue.toString() !== initialValue.toString()) {
        field.dataset.touched = "true";
      }
    }

    const isTouched = field.dataset.touched === "true";

    // APPLY SUCCESS
    if (isValid && isTouched) {
      field.classList.add("ctm-success");
      parent?.classList.add("ctm-success");
    } else {
      field.classList.remove("ctm-success");
      parent?.classList.remove("ctm-success");
    }
  };

  const handleFieldChange = (e) => {
    const field = e.target;

    if (!isInsideForm(field)) return; // ONLY FORM FIELDS

    applySuccess(field);
  };

  // SET INITIAL VALUES (ONLY FOR FORM FIELDS)
  const setInitialValues = () => {
    const allFields = document.querySelectorAll(
      "form input, form textarea, form select"
    );

    allFields.forEach((field) => {
      if (!isTrackedField(field)) return;

      if (!field.dataset.initialValueSet) {
        field.dataset.initialValue = field.value ?? "";
        field.dataset.initialValueSet = "true";
      }
    });
  };

  // Run after render (important for React)
  setTimeout(setInitialValues, 0);

  // Handle dynamically added fields
  const handleFocus = (e) => {
    const field = e.target;

    if (!isTrackedField(field)) return;
    if (!isInsideForm(field)) return; // ONLY FORM FIELDS

    if (!field.dataset.initialValueSet) {
      field.dataset.initialValue = field.value ?? "";
      field.dataset.initialValueSet = "true";
    }
  };

  // LISTEN TO USER EVENTS
  document.addEventListener("input", handleFieldChange);
  document.addEventListener("change", handleFieldChange);
  document.addEventListener("focus", handleFocus, true);

  // CLEANUP
  return () => {
    document.removeEventListener("input", handleFieldChange);
    document.removeEventListener("change", handleFieldChange);
    document.removeEventListener("focus", handleFocus, true);
  };
};
